(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-slider"] && !Shopify.designMode) return;
  try {
    
var swiper = new Swiper('.custom-slider', {
  loop: true,
  autoplay: { delay: 5000 },
  pagination: { el: '.swiper-pagination', clickable: true },
  navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
});

  } catch(e) { console.error(e); }
})();
})();
